// p2p multi-address code
export const CODE_P2P = 421
export const CODE_CIRCUIT = 290

// Time to wait for a connection to close gracefully before destroying it manually
export const CLOSE_TIMEOUT = 2000
